import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Box, LinearProgress, Typography } from '@material-ui/core';
import {
  getHomePictreeReportTsuru,
} from "actions";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    tooltip: {
      position: 'absolute',
      top: '8px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '5px 10px',
      borderRadius: '4px',
      fontSize: '14px',
      whiteSpace: 'nowrap',
    },
    box: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      borderRight: "1px solid #dcdcdc",
    },
    boxLast: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(0),
    },
    title: {
      display: "block",
      height: 32,
      fontSize: 14,
    },
    value: {
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: 150,
    },
  })
);

const TsuruSummary = ({
  homeDataReportTsuru,
  getHomePictreeReportTsuru,
  dateRangePicTree
}) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    if (dateRangePicTree[0] !== null && dateRangePicTree[1]!== null
      && initialDataCall) {
      getHomePictreeReportTsuru();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Grid container spacing={1}>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >ツルツタ撮影基数</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.totalCount !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.totalCount)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >ツルツタ報告数</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.reportCount !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.reportCount)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >ツルツタ電柱/報告あり</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countLedgerAndReport !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countLedgerAndReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >ツルツタ電柱/報告なし</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countLedgerAndNoReport  !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countLedgerAndNoReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >通常電柱/報告あり</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countNoLedgerAndReport !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countNoLedgerAndReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={6} md={4} lg={2}>
            <div className={classes.box}>
              <Grid container direction={"row"}>
                <Grid item xs={11}>
                  <Typography
                    variant="caption"
                    className={classes.title}
                  >通常電柱/報告なし</Typography>
                </Grid>
                <Grid item xs={1} sm={6} md={4}>
                  <Typography variant="h6" className={classes.value}>
                    {homeDataReportTsuru.countNoLedgerAndReport !== undefined
                      ? `${H.FormatNumStrHelper.formatCommaThousand(homeDataReportTsuru.countNoLedgerAndNoReport)}`
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

TsuruSummary.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  homeDataReportTsuru: state.pictree.homeDataReportTsuru,
  dateRangePicTree: state.page.dateRangePicTree,
});

const mapDispatchToProps = (dispatch) => ({
  getHomePictreeReportTsuru: () => dispatch(getHomePictreeReportTsuru()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(TsuruSummary));
